<template>
  <div> 
    <div class='glitchHolder'>
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div v-for="g in glitches" class='glitchOver' :style="{marginBottom:g.pad+'px',width:g.width+'%'}">
        <div v-for="gc in g.child" class='glitchChild' :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"></div>
        </div>
      </div>
    </div>
    <v-container ma-0 pt-0  >
      <v-layout >
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular indeterminate :size="50" 
            color="grey" 
            :width="7" 
            v-if="loading"></v-progress-circular>
        </v-flex>
      </v-layout>    
      <v-layout>
        <v-flex xs12 offset-xs0 sm10 offset-sm2 pa-2 >
       
          <h2>Submission Guidelines for The Loop</h2>
          <p>To ensure that your video is played at the highest quality for the platform, please
follow these guidelines for vision and audio formatting before uploading content
directly to the Loop.</p>
          <h2>Accepted video file formats</h2>
          <ul>
            <li>MPEG-4 / mp4 (recommended video codec: H.264)</li>
            <li>Maximum 4GB file size</li>
          </ul>
          <h2>Audio</h2>
          <ul>
            <li>It’s important that your audio is good quality and normalised to ensure volume
consistency across all content on The Loop</li>
            <li>If your audio is very poor quality we may not be able to screen it</li>
          </ul>

          <h2>Accessibility</h2>
          <p>We strongly recommend that you provide text captioning and audio description to all
the content you submit so that it aligns with our Accessibility and Inclusion Policy.
Most current editing software provides automated captioning to assist in this process
it is your responsibility to check the accuracy of all captioning for your content.</p>
          
          <h2>Other material required</h2>
          <ul>
            <li>a still image that is indicative of your content –</li>
<li>If you are submitting video for a particular Loop program please tag the name
of the program in the Loop submission portal</li>
          </ul>
          
          
          <h2>Screen specs</h2>
          <ul>
            <li>Screen size: 4800 x 2880mm at a 5mm pitch</li>
            <li>Output resolution: 960 x 576 (square pixels) – This refers to the resolution of visible area
of the screen that your film will play at. It is ok to submit your content at full HD 1920x1080 the Loop will scale it appropriately.</li>
            <li>The screen is not 16:9, it is slightly narrower. By Default your image will be cropped If your video does not fit these
dimensions, we can adjust the scale so that it plays letterboxed if required. Please let us know your preference in advance.</li>
<li>Please ensure all titles/subtitles and other important graphics are not cropped.</li>
          </ul>
         
            <h2>License and Agreement</h2>
            <p>You must complete this <v-btn  href="https://au.openforms.com/Form/fadca18a-afd1-4452-b8c4-bdc6f4ac542c">agreement and declaration</v-btn> in order to give permission for
your content to be screened on the Loop.</p>

              <h2>Get in touch</h2>
              <p>
                If you have particular questions or require assistance with your submission please
contact Tobias Hengeveld – Public Art Project Officer for the City of Hobart – call
(03) 62382565 or email hengeveldt@hobartcity.com.au or
pulicart@hobartcity.com.au
              </p>
<p>
<div v-if="!userIsAuthenticated"><b>You need an account to sumbit content. </b>
<v-btn  to="/signin"><v-icon left>lock_open</v-icon>Sign In</v-btn>
<v-btn  to="/signup"><v-icon left>face</v-icon>Sign Up</v-btn>
</div>
<div v-if="userIsAuthenticated" style="text-align:center">
<v-btn  to="/content/new"><v-icon >movie</v-icon>&nbsp;Upload Content</v-btn> </div>
</p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
 export default {
   
   data () {
     return {
       glitches:null,
       glitchCount:20,
       glitchTop:0
     }
   },
   mounted(){
     this.glitches=[]
     let childA=[]  
      for(var i=0;i<8;i++){
        childA=[]
        for(var p=0;p<2;p++){
          childA.push(Math.floor(Math.random()*100));   
        }
        this.glitches.push({colour:'#00000044',height:30,pad:3,width:Math.random()*50+50,child:childA})
      }
      setTimeout(this.glitch,100);
   },
   computed: {
     loading () {
       return this.$store.getters.loading
     },
     userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    
    },
   methods: {
     glitch(){

        this.glitchCount++
        if(this.glitchCount>50){
            this.glitchCount=Math.random()*20-10
            this.glitchTop=Math.random()*400+100;
        }
       if(this.glitchCount>10){
         this.glitchCount+=Math.random()*40
          setTimeout(this.glitch,Math.random()*100+100);
          
          return
         
       }
        
       
        for(var g in this.glitches){
          if(Math.random()*10>7){
            this.glitches[g].height=Math.random()*20+5;
            for(var gc in this.glitches[g].child){
                this.glitches[g].child[gc]=Math.floor(Math.random()*160+20);
            }
             if(Math.random()*10>5){
               this.glitches[g].height=0;
             }
          }
          this.glitches[g].pad=Math.floor(Math.random()*5+5)
          this.glitches[g].width=Math.floor(Math.random()*160+20) 
        }
        if(Math.random()*10>5){
         // this.glitchTop=Math.random()*400+100;
        }
        setTimeout(this.glitch,100);
     }
     
   }
 }
</script>

<style scoped>
  .glitchHolder{
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    pointer-events: none;
  }
  #glitchOverlay{
  position:absolute;
  left:-100px;
  top:0px;
}
.glitchOver{
  
  z-index:3;
  position:relative;
  min-height:30px;
  pointer-events:none;
  opacity:0.3;
  width:400px;
  
}
.glitchChild{
  width:40px;
  display:inline-block;
  background-color:#00f;
}

</style>



// WEBPACK FOOTER //
// src/components/Submissions.vue